import { Practitioner } from "src/app/ui/models/domains/pbm/practitioner-management/practitioner";
import { PractitionerSpecialty } from "src/app/ui/models/domains/pbm/practitioner-management/practitioner-specialty";
import { PractitionerStatus } from "src/app/ui/models/domains/pbm/practitioner-management/practitioner-status";
import { SearchPractitionerResult } from "src/app/ui/models/domains/pbm/practitioner-management/search-practitioner.result";
import { StateAcronym } from "src/app/ui/models/domains/pbm/state/state-acronym";

export function parseSearchPractitionerResult(payload: any): SearchPractitionerResult {
  const result = new SearchPractitionerResult();
  result.setStart(payload.Start);
  result.setTotal(payload.Total);
  result.setTotalPerPages(payload.TotalPerPages);
  result.setPractitioners(parsePractitioners(payload.Data));
  return result;
}

export function parsePractitioners(payload: any): Practitioner[] {
  return payload.map((item) => {
    return parsePractitioner(item);
  });
}

export function parsePractitioner(payload: any): Practitioner {
  const practitioner = new Practitioner();
  practitioner.setKey(payload.PractitionerKey.Value);
  practitioner.setName(payload.Name);
  practitioner.setStateAcronym(new StateAcronym(payload.PractitionerRegistration.State.Value));
  practitioner.setRegistration(payload.PractitionerRegistration.Registration);
  practitioner.setStatus(parsePractitionerStatus(payload.PractitionerStatus));
  practitioner.setSpecialties(parsePractitionerSpecialties(payload.Specialties));
  return practitioner;
}

export function parsePractitionerSpecialties(payload: any): PractitionerSpecialty[] {
  return payload.map((item) => {
    return parsePractitionerSpecialty(item);
  });
}

export function parsePractitionerSpecialty(payload: any): PractitionerSpecialty {
  const specialty = new PractitionerSpecialty();
  specialty.setKey(payload.PractitionerSpecialtyKey.Value);
  specialty.setDescription(payload.Description);
  return specialty;
}

export function parsePractitionerStatusList(payload: any): PractitionerStatus[] {
  return payload.map((item) => parsePractitionerStatus(item));
}

export function parsePractitionerStatus(payload: any): PractitionerStatus {
  return new PractitionerStatus(payload.Key.Value, payload.Description);
}
